import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

export const FinalCta = () => (
  <section
    id="cta-finale"
    className="relative overflow-hidden bg-[#080808] py-24 sm:py-32"
  >
    <div
      className="pointer-events-none absolute inset-x-0 top-0 gold-hairline"
      aria-hidden="true"
    />
    <div className="mx-auto max-w-3xl px-6 text-center lg:px-8">
      <Reveal>
        <h2
          data-testid="final-cta-heading"
          className="font-display text-4xl font-semibold leading-tight tracking-tight text-white sm:text-5xl"
        >
          La tua fede non deve{" "}
          <span className="text-[#C9A45C]">rimanere ferma</span>.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-8 space-y-2 text-base leading-relaxed text-[#B8B8B8] sm:text-lg">
          <p>Non devi essere perfetto per iniziare.</p>
          <p>Non devi conoscere già tutta la Bibbia.</p>
          <p>Non devi affrontare tutto da solo.</p>
          <p className="pt-3">
            Puoi iniziare oggi a costruire nuove abitudini, approfondire la fede
            e prenderti cura della persona che Dio ti ha chiamato a essere.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:justify-center">
          <CtaButton
            plan="app"
            testid="final-cta-app-button"
            variant="secondary"
            className="w-full sm:w-auto"
          >
            Inizia con l'App — 9,99 €/mese
          </CtaButton>
          <CtaButton
            plan="community"
            testid="final-cta-community-button"
            className="w-full sm:w-auto"
          >
            Entra nella Community — 49 €/mese
          </CtaButton>
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-20">
          <p className="font-display text-3xl font-semibold uppercase tracking-[0.2em] text-[#C9A45C]">
            Tempio Vivo
          </p>
          <p className="mt-4 text-sm font-semibold uppercase tracking-[0.25em] text-white">
            Trasforma la tua vita con Dio al centro.
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[#B8B8B8]">
            Fede • Fitness • Famiglia
          </p>
          <p className="font-display mt-6 text-xl italic text-[#E8D5A3]">
            Fede in Azione.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
